export default "__VITE_ASSET__PKJJTiN___"